import React, { ReactElement, useState } from "react";
import { BiPlayCircle } from "react-icons/bi";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { StepProps } from "./base";
import { ChannelMode } from "../../../__generated__/api";
import Help, { ARTICLES } from "../../../components/help/Help";

export default function OnboardingStep(props: StepProps): ReactElement {
    const [profile, setProfile] = useState(props.profile);
    return (
        <div>
            <Help articleId={ARTICLES.CONTACTED_PAGE} />
            <h2>How do you want to be contacted?</h2>
            <p>
                How do you want people to create requests? Just by typing a message in a channel,
                using emoji&apos;s, or using the channel menu? You can also mix and match modes by
                selecting multple options below.
            </p>

            <div className="d-flex list-group flex-row w-100 gap-2">
                <div className="text-center d-flex flex-column">
                    <button
                        onClick={() => setProfile({
                            ...profile,
                            channelMode: profile.channelMode === ChannelMode.Threaded ? undefined : ChannelMode.Threaded,
                            isEmojiEnabled: false,
                        })}
                        type="button"
                        className={`list-group-item list-group-item-action flex-grow-1 p-3 rounded hover-shadow ${
                            profile.channelMode === ChannelMode.Threaded ? "bg-blue-light text-white" : ""}`}
                    >
                        {profile.channelMode === ChannelMode.Threaded && (
                            <div className="position-absolute top-0 start-0 ms-2 mt-2">
                                <AiOutlineCheckCircle size="20" />
                            </div>
                        )}
                        <strong>Threaded</strong>
                        <p>
                            When a user types a message in a channel, Foqal creates a thread and responds automatically.
                        </p>
                    </button>

                    <Help
                        articleId={ARTICLES.CONTACT_EXPLAIN_THREADED}
                        buttonClassName="btn btn-none d-block mx-auto mt-2"
                        button={(
                            <>
                                <BiPlayCircle />
                                {" "}
                                Explain Threaded
                            </>
                        )}
                    />

                </div>
                <div className="text-center d-flex flex-column">
                    <button
                        onClick={() => setProfile({
                            ...profile,
                            channelMode: ChannelMode.Manual,
                            isEmojiEnabled: !profile.isEmojiEnabled,
                        })}
                        type="button"
                        className={`list-group-item list-group-item-action flex-grow-1 p-3 rounded hover-shadow ${
                            profile.isEmojiEnabled ? "bg-blue-light text-white" : ""}`}
                    >
                        {profile.isEmojiEnabled && (
                            <div className="position-absolute top-0 start-0 ms-2 mt-2">
                                <AiOutlineCheckCircle size="20" />
                            </div>
                        )}
                        <strong>Emoji</strong>
                        <p>
                            Would you prefer to use an emoji to manually convert a Slack message or thread into a ticket.
                        </p>
                    </button>
                    <Help
                        articleId={ARTICLES.CONTACT_EXPLAIN_EMOJI}
                        buttonClassName="btn btn-none d-block mx-auto mt-2"
                        button={(
                            <>
                                <BiPlayCircle />
                                {" "}
                                Explain Emoji
                            </>
                        )}
                    />
                </div>
                <div className="text-center d-flex flex-column">
                    <button
                        onClick={() => setProfile({
                            ...profile,
                            channelMode: profile.channelMode ?? ChannelMode.Manual,
                            isChannelMenuEnabled: !profile.isChannelMenuEnabled,
                        })}
                        type="button"
                        className={`list-group-item list-group-item-action flex-grow-1 p-3 rounded hover-shadow ${
                            profile.isChannelMenuEnabled ? "bg-blue-light text-white" : ""}`}
                    >

                        {profile.isChannelMenuEnabled && (
                            <div className="position-absolute top-0 start-0 ms-2 mt-2">
                                <AiOutlineCheckCircle size="20" />
                            </div>
                        )}
                        <strong>Channel Menu</strong>
                        <p>
                            The Channel Menu sticks to the bottom of the Slack channel and allows users to create
                            requests from forms.
                        </p>
                    </button>
                    <Help
                        articleId={profile.isExternalSupport
                            ? ARTICLES.CONTACT_EXPLAIN_CHANNEL_MENU_EXTERNAL
                            : ARTICLES.CONTACT_EXPLAIN_CHANNEL_MENU_INTERNAL}
                        buttonClassName="btn btn-none d-block mx-auto mt-2"
                        button={(
                            <>
                                <BiPlayCircle />
                                {" "}
                                Explain Channel Menu
                            </>
                        )}
                    />
                </div>
            </div>
            <div className="mt-4 text-end w-100">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => props.onNext(profile)}
                >
                    Next
                </button>
            </div>

        </div>
    );
}
